import { render, staticRenderFns } from "./Textbook.vue?vue&type=template&id=52241c08&scoped=true&"
import script from "./Textbook.vue?vue&type=script&lang=js&"
export * from "./Textbook.vue?vue&type=script&lang=js&"
import style0 from "./Textbook.vue?vue&type=style&index=0&id=52241c08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52241c08",
  null
  
)

export default component.exports